import { Card, Typography, styled } from '../../../base';

export const CommentItem = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(1.5),
}));

export const CommentDate = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[400],
}));

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    display: 'flex',
    height: '100%',
    width: '100%',
}));

export const ContentWrapper = styled('div')(() => ({
    display: 'flex',
    height: '100%',
    width: '100%',
}));

export const ScrollableComments = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(1),
    maxHeight: '120px',
    overflowY: 'auto',
    marginBottom: theme.spacing(2),
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        background: theme.palette.background.paper,
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[400],
        borderRadius: '3px',
    },
}));
